import * as zod from 'zod';

import { TCPOffsetOptionStrict } from '@sb/motion-planning';

export default zod.object({
  // Strict on purpose: this step's option IS the motion identity, and its
  // producers include paths that never meet a validator (SDK, DSL, external
  // control). An unrecognized or missing option fails at loadRoutine rather
  // than degrading to 'wrist' and silently playing the flange.
  tcpOption: TCPOffsetOptionStrict,
  gripperID: zod.string().optional(),
});
